module.exports = __webpack_public_path__ + "img/14_43.4ef362c8.png";